var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intervals" },
    _vm._l(_vm.pickup.intervals, function(interval, intervalIndex) {
      return _c("Interval", {
        key: intervalIndex,
        staticClass: "interval",
        attrs: { "remove-btn": "", interval: interval },
        on: {
          change: function($event) {
            return _vm.updateInterval({ index: intervalIndex, value: $event })
          },
          remove: function($event) {
            return _vm.removeInterval(intervalIndex)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }